import { render } from "./FaqDisplay.vue?vue&type=template&id=94d8cf54&scoped=true&ts=true"
import script from "./FaqDisplay.vue?vue&type=script&lang=ts"
export * from "./FaqDisplay.vue?vue&type=script&lang=ts"

import "./FaqDisplay.vue?vue&type=style&index=0&id=94d8cf54&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94d8cf54"]])

export default __exports__